import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../globalError";
import { LIMITED_PERMISSIONS } from "../customerProfile";

export function handleApiErrors(result) {
  if (result.reasons) {
    if (result.code == 401) {
      if (
        result.reasons.find(
          (x) =>
            x.description.indexOf(
              "Current user does not have the right to view this customer"
            ) > -1
        )
      ) {
        return {
          error: {
            type: LIMITED_PERMISSIONS,
            data: {
              canViewCustomerProfile: false,
              canEditCustomerProfile: false,
            },
          },
        };
      } else if (
        result.reasons.find(
          (x) =>
            x.description.indexOf(
              "This user does not have an access to view this invoice"
            ) > -1
        )
      ) {
        return {
          error: {
            type: LIMITED_PERMISSIONS,
            data: { canCheckoutAllBookings: false },
          },
        };
      } else if (
        result.reasons.find(
          (x) =>
            x.description.indexOf(
              "Current user does not have the right to create a customer."
            ) > -1
        )
      ) {
        return {
          error: {
            type: UPDATED_GLOBAL_ERROR_MESSAGE,
            data: window.APP.LANGUAGE.Errors.NoAccessToCreateCustomer,
          },
        };
      } else if (
        result.reasons.find(
          (x) =>
            x.description.indexOf(
              " Current user does not have the right to create a new booking for other staff."
            ) > -1
        )
      ) {
        return {
          error: {
            type: UPDATED_GLOBAL_ERROR_MESSAGE,
            data:
              window.APP.LANGUAGE.Errors.NoAccessToCreateBookingForOtherStaff,
          },
        };
      } else if (
        result.reasons.find(
          (x) =>
            x.description.indexOf(
              "Current user does not have the right to edit a customer."
            ) > -1
        )
      ) {
        return {
          error: {
            type: UPDATED_GLOBAL_ERROR_MESSAGE,
            data: window.APP.LANGUAGE.Errors.NoAccessToEditCustomer,
          },
        };
      } else {
        return {
          error: {
            type: UPDATED_GLOBAL_ERROR_MESSAGE,
            data: window.APP.LANGUAGE.Errors.UnauthenticatedError,
          },
        };
      }
    }
    if (result.reasons.indexOf("offernotfound") > -1) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.OfferNotFoundError,
        },
      };
    }
    if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "Times not available, recurrence clashes with existing booking"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data:
            window.APP.LANGUAGE.Errors.TimesNotAvailableSinceExistingAlready,
        },
        responseData: result,
        timeNotAvailable: true,
      };
    }
    if (
      result.reasons.find(
        (x) => x.description.indexOf("you cannot mark a booking as New") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data:
            window.APP.LANGUAGE.Errors.BookingStatusInvalidAndCannotBeUpdated,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("Time not available") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.TimeNotAvailable,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("security code is incorrect") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.SecurityCodeOrExpiryDateIsIncorrect,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "An error occurred authenticating your credit card details"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.ErrorAuthenticatingCreditCardDetails,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "Cannot change starttime on a recurring booking that is not the first in the series"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.CannotChangeStartTimeRecurring,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("Failed to add new card for") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.FailedToAddNewCard,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "Available duration is required when second duration is provided"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.FreeTimeRequired,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("until date cannot be before endtime") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.UntilDateCannotBeBeforeTime,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("Second duration is required") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.SecondDurationRequired,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf("the weekdays must at least include SUNDAY") >
          -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.SundayWeekdayRequired,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf("the weekdays must at least include MONDAY") >
          -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.MondayWeekdayRequired,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf("the weekdays must at least include TUESDAY") >
          -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.TuesdayWeekdayRequired,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "the weekdays must at least include WEDNESDAY"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.WednesdayWeekdayRequired,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf("the weekdays must at least include THURSDAY") >
          -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.ThursdayWeekdayRequired,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf("the weekdays must at least include FRIDAY") >
          -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.FridayWeekdayRequired,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf("the weekdays must at least include SATURDAY") >
          -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.SaturdayWeekdayRequired,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "Another customer with this email and name already exists"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.DuplicatedEmail,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "Missing or invalid value for weekdays, must have at least one"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.MustHaveAtLeastOneWeekDaySelected,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "You cannot have specific dates recurrence without inclusiondates"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.MustSelectRecurringTimes,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "Cannot split an already recurrent booking in new recurrent booking"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.CannotSplitRecurringAppointment,
        },
      };
    } else if (
      result.reasons.find((x) => x.description.indexOf("ZIP is invalid") > -1)
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.ZipInvalid,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("Post code is invalid") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.PostCodeInvalid,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("Phone number is invalid") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.PhoneNumberIsInvalid,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("invalid value for starttime") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.InvalidValueForStartTime,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "Cannot create an invoice for a recurring booking"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data:
            window.APP.LANGUAGE.Errors.CannotCreateInvoiceForRecurringBooking,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("Invoice cannot be overpaid.") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.InvoiceCantBeOverpaid,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("Invalid existing payments") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.MaximumCardPayment,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "Cannot set exclusiondates with a None or Specific days recurring recurrence."
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data:
            window.APP.LANGUAGE.Errors
              .CannotExcludeTimesForASpecificDaysRecurrence,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("Your credit card has been declined") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.CreditCardDeclined,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf("Amount must be greater than or equal to $1") >
          -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.MinimumPaymentUnreached,
        },
      };
    } else if (
      result.reasons.find(
        (x) => x.description.indexOf("Amount must be less than $10000") > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data: window.APP.LANGUAGE.Errors.MaximumPaymentReached,
        },
      };
    } else if (
      result.reasons.find(
        (x) =>
          x.description.indexOf(
            "Another customer with this phonenumber and name already exists"
          ) > -1
      )
    ) {
      return {
        error: {
          type: UPDATED_GLOBAL_ERROR_MESSAGE,
          data:
            window.APP.LANGUAGE.Errors.AnotherCustomerWithThisPhoneNumberExists,
        },
      };
    } else {
      let reason = result.reasons[0];
      if (reason && reason.description) {
        return {
          error: {
            type: UPDATED_GLOBAL_ERROR_MESSAGE,
            data: reason.description,
          },
        };
      } else {
        return {
          error: {
            type: UPDATED_GLOBAL_ERROR_MESSAGE,
            data: window.APP.LANGUAGE.Errors.UnknownApiError,
          },
        };
      }
    }
  } else if (result.generalError) {
    return {
      error: {
        type: UPDATED_GLOBAL_ERROR_MESSAGE,
        data: window.APP.LANGUAGE.Errors.InvalidID,
      },
    };
  } else {
    console.error("unknownapierrordetected", result);
    return {
      error: {
        type: UPDATED_GLOBAL_ERROR_MESSAGE,
        data: window.APP.LANGUAGE.Errors.UnknownApiError,
      },
    };
  }
}

export function IsvalidId(value) {
  const paresedId = parseInt(value, 0);

  if (isNaN(paresedId)) return false;
  return true;
}
